import type { PaginatedResponse } from "@/types/common.types";
import { CommodityCommitedByActivity } from "./commodities";

export interface Activity {
  id: string;
  name: string;
  code: string;
  cover: string;
  createdAt: string;
  description: string;
  start_time: string;
  end_time: string;
  products: CommodityCommitedByActivity[]; // 关联商品列表
  status: ActivityStatus;
  updatedAt: string;
}

// 用于状态下拉框的选项
export const STATUS_OPTIONS = [
  { value: "all", label: "全部" },
  { value: "active", label: "使用中" },
  { value: "inactive", label: "下架" },
  { value: "draft", label: "未发布" },
  { value: "expired", label: "过期" },
];
export const UNIT_OPTIONS = [
  { value: "year", label: "年" },
  { value: "month", label: "月" },
];
export const ActivityStatu = {
  ["active"]: "使用中",
  ["inactive"]: "下架",
  ["draft"]: "未发布",
  ["expired"]: "过期",
};

// 课程状态：1-使用中，2-下架
export type ActivityStatus = "active" | "inactive" | "draft" | "expired";
export type ActivityUnit = "year" | "month";

export type ActivitiesResponse = PaginatedResponse<Activity>;

export type GetActivitiesParams = {
  page: number;
  page_size: number;

  platform: string;

  // 查询条件
  title?: string; // 课程名称

  // 状态筛选
  status?: ActivityStatus | "all";
  unit: string;
};
